import { Injectable, inject } from '@angular/core';
import { VwApiRequestsService } from 'vwappservices';

@Injectable({ providedIn: 'root' })
export class MachineTypesApiService {
  private api = inject(VwApiRequestsService);

  list() {
    return this.api.getAPICall('/machine-types');
  }

  get(id: string) {
    return this.api.getAPICall(`/machine-types/${id}`);
  }

  create(payload: { name: string; description?: string; downtimeReasons?: string[] }) {
    return this.api.postAPICall('/machine-types', payload);
  }

  update(id: string, payload: Record<string, any>) {
    return this.api.postAPICall(`/machine-types/${id}`, payload);
  }

  delete(id: string) {
    return this.api.postAPICall(`/machine-types/${id}/delete`, {});
  }

  addReason(machineTypeId: string, payload: { name: string }) {
    return this.api.postAPICall(`/machine-types/${machineTypeId}/reasons`, payload);
  }

  updateReason(machineTypeId: string, reasonId: string, payload: Record<string, any>) {
    return this.api.postAPICall(`/machine-types/${machineTypeId}/reasons/${reasonId}`, payload);
  }

  deleteReason(machineTypeId: string, reasonId: string) {
    return this.api.postAPICall(`/machine-types/${machineTypeId}/reasons/${reasonId}/delete`, {});
  }
}
